import { Link } from 'react-router';
import { matchPath } from 'react-router';
import isEmpty from 'lodash/isEmpty';
import Badge from 'antd/es/badge';

export const buildMenu = menus => {
  return menus.map(menu => {
    const menuItem = {
      key: menu.path,
      icon: menu.icon,

      label: (
        <Link to={menu.path}>
          <span>{menu.label}</span>
          {menu.isNew && <Badge style={{ marginLeft: 5 }} dot />}
        </Link>
      ),
    };

    if (!isEmpty(menu.children)) {
      menuItem.label = menu.label;
      // @ts-ignore
      menuItem.children = buildMenu(menu.children);
    }

    return menuItem;
  });
};

export const selectedKeys = (url: string, menu: any[]) => {
  const match = menu.find(option => {
    return matchPath(
      {
        ...option,
        path: option.parentPath || option.path,
      },
      url,
    );
  });

  if (match) {
    return [match.path];
  }
};
